import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { motion, AnimatePresence } from 'framer-motion';

export default function Layout() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-[#14080b] text-[#f8f3f4]">
      {/* Glow background */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-32 right-0 h-80 w-80 rounded-full bg-brand-500/25 blur-3xl sm:w-[420px]" />
        <div className="absolute -bottom-24 left-0 h-72 w-72 rounded-full bg-rose-400/20 blur-3xl sm:w-[360px]" />
        <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-[#1e0d12] via-[#1e0d12]/70 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-[#1e0d12] via-[#1e0d12]/70 to-transparent" />
      </div>

      <Navbar />

      <main className="relative z-10 flex-1">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}
